import React from 'react'
import BodyRender from 'scripts/components/article/BodyRender'
import Reactions from 'scripts/components/article/Reactions'
import MobileMeta from 'scripts/components/article/MobileMeta'
import SideBar from 'scripts/components/article/SideBar'
import SimilarArticles from 'scripts/components/article/SimilarArticles'
import Metas from 'scripts/components/article/Metas'
import Prefooter from 'scripts/components/Prefooter'
import { PaddedAssociations, PaddedImage } from 'scripts/helpers/AppHelper'
import { extractSubType, decodeHTML } from 'scripts/lib/utils'
import Discussion from 'scripts/components/disqus/Discussion'
import NotFound from 'scripts/components/notfound'
import Ad from 'scripts/components/ad'
import ConsentCookie from 'scripts/lib/ConsentCookie'
import SocialMediaShare from './SocialMediaShare'
import HeroIframe from 'scripts/components/article/HeroIframe/HeroIframe'
import {actions} from 'scripts/store'
import locale, {getLang} from 'shared/i18n/react'
import TakeoverAd from 'scripts/components/TakeoverAd'
import { LazyLoadWrapper } from '@viki-ui/lazy-load'
import Constants from 'scripts/base/Constants'

const LazyLoadedSimilarArticles = LazyLoadWrapper(SimilarArticles)
const LazyLoadedPrefooter = LazyLoadWrapper(Prefooter)

const SideBarElement = (props) => {
  const {id, ssr, tagsFC} = props
  if (ssr || tagsFC.length === 0) { return null }
  const relatedRandom = tagsFC.length > 1 ? Math.ceil(Math.random() * (tagsFC.length - 1)) : 0
  return (
    <SideBar relatedTag={tagsFC[relatedRandom]} postId={id} />
  )
}

const LazyLoadedSimilarElement = (props) => {
  const {id, ssr, cate} = props
  if (ssr || cate.length === 0) { return null }
  return (
    <LazyLoadedSimilarArticles similarCategory={cate[0]} postId={id} />
  )
}

const HeroContent = (props) => {
  let heroContent
  const {videoURL, imageURL, titleText} = props
  if (videoURL && videoURL !== '') {
    heroContent = (
      <HeroIframe src={ videoURL }/>
    )
  } else {
    heroContent = (
      <PaddedImage image={imageURL} containerClass='image-wrapper' altText={decodeHTML(titleText)} />
    )
  }
  return heroContent
}

const CommentsElement = (props) => {
  const {id, ssr, disqusShortname, disqusConfig} = props
  const consent = new ConsentCookie()
  if (ssr || !id || !consent.hasConsent('social')) { return null }
  return (
    <Discussion shortname={disqusShortname} config={disqusConfig} />
  )
}
const sectionSetCategory = () => {
  actions.setSection('category_label')
}
const sectionSetTag = () => {
  actions.setSection('tag_label')
}
class ArticleRender extends React.Component {
  componentDidUpdate(prevProps) {
    console.log('A1::- ' + prevProps.article.title.text)
    console.log('A2::- ' + this.props.article.title.text)
    const path = window.location.pathname
    let code = this.validateCustomURL(path);
    if (prevProps.article.title.text === this.props.article.title.text) {
      const dateObj = new Date(this.props.article.createdAt * 1000);
      console.log('GA1:- ' + dateObj)
      const formattedDate = dateObj.getDate() + '/' + (dateObj.getMonth() + 1) + '/' +    dateObj.getFullYear();
      console.log('GA2:- ' + formattedDate)
      this.pushDataToDataLayer(this.props,formattedDate,code)
    }
  }

  validateCustomURL(url) {
    var pattern = /^\/es\/article/i;
    return pattern.test(url);
  }

  pushDataToDataLayer(data,formattedDate,code) {

    var articleCategoryType = "DN";
    var siteCode = "EN";
    if(code){
      siteCode = "ES";
    }
    var categoryArray = []
    if(typeof data.article.associatedWith != "undefined" && data.article.associatedWith.length > 0){
      for (var i = 0; i < data.article.associatedWith.length; i++) {
        if (data.article.associatedWith[i].id === "19533wpc" || data.article.associatedWith[i].id === "16519wpc") {
          articleCategoryType = "Featured";
        }
        if (data.article.associatedWith[i].type === "category") {
          categoryArray.push(data.article.associatedWith[i]);
        }
      }
    }
    var categoryArrayJSON = JSON.stringify(categoryArray);
    console.log(siteCode+' GA3::- ' + articleCategoryType)
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      'Article_Title': data.article.title.text,
      'Article_Id': data.article.id,
      'Article_Author': data.article.author.displayName,
      'Article_Author_Id': data.article.author.id,
      'Article_Publish_Date': formattedDate,
      'Article_Categories': categoryArrayJSON,
      'Article_Category_Type': articleCategoryType,
      'Article_Code': siteCode
    })
  }

  render() {
    if (this.props.hasError) {
      return <NotFound />
    }
    const { article: {id, images, videos, createdAt: date, author, title, content, associatedWith, url, reactions}, ads, ssr } = this.props
    const imageURL = images && images.header ? images.header.url : null
    const videoURL = videos && videos.header ? videos.header.url : null
    const titleText = title ? title.text : null
    const tags = associatedWith ? extractSubType(associatedWith, 'tag', Constants.TrackingTags) : []
    const fanClubs = associatedWith ? extractSubType(associatedWith, 'fanClub') : []
    const cate = associatedWith ? extractSubType(associatedWith, 'category') : []
    const lang = getLang()
    let disqusShortname = process.env.NODE_ENV === 'production' ? 'soompi' : 'soompidev'
    if (lang === 'es') {
      disqusShortname = `${disqusShortname}spanish`
    }
    const webUrl = url ? url.web : null
    const disqusConfig = {
      url: webUrl,
      identifier: id,
      title: titleText,
      api_key: (typeof global.app !== 'undefined' ? global.app.disqusKey : '')
    }

    const contentBody = content ? content.bodyHTML : null
    const lazyLoadedPrefooterElement = !ssr ? <div><LazyLoadedPrefooter /></div> : null
    const reactionsConf = {
      title: locale.reactions.title,
      settings: { id, reactions }
    }
    const reactionsElement = <Reactions {...reactionsConf} />
    return (
      <div className="article-body container-main">
        {ads && <TakeoverAd />}
        <Metas {...this.props} lang={lang}/>
        <div className="container article-content pos-relative">
          <div className="row">
            <div className="col small-12 med-8 article-section">
              <HeroContent imageURL={imageURL} videoURL={videoURL} titleText={titleText} />
              <div className="article-paragraph">
                <div className="article-info">
                  <h1>{titleText}</h1>
                  <div className="author-date">
                    <MobileMeta category={cate} author={author} date={date * 1000} costumOnClick={sectionSetCategory} />
                  </div>
                </div>
                {/* <MobileActions /> */}
                {ads && <Ad {...ads.adHeader} className="after-article-header"/>}
                <div className="article-wrapper">
                  <BodyRender html={contentBody} />
                  <div className="article-footer">
                    <PaddedAssociations
                      type='fanclub'
                      data={fanClubs}
                      containerClass='article-fanclubs'
                      assocClass='badges fanclubs fanclub-item'
                      costumOnClick={sectionSetTag}
                    />
                    <PaddedAssociations
                      type='tag'
                      data={tags}
                      containerClass='article-tags'
                      assocClass='badges tags tag-item'
                      costumOnClick={sectionSetTag}
                    />
                  </div>
                  {ads && <Ad {...ads.adBeforeComment} />}
                  {reactionsElement}
                  <SocialMediaShare url={webUrl} description={titleText} image={imageURL} />
                  <CommentsElement id={id} ssr={ssr} disqusShortname={disqusShortname} disqusConfig={disqusConfig} />
                </div>
              </div>
            </div>
            <div className="col small-12 med-4">
              {ads && <Ad {...ads.adSideTop}/>}
              {/* Note: SideBar as of now only has one element which
                is the Related articles. And currently randomly cylcing
                through the tags of the current article minus itself */}
              <SideBarElement id={id} tagsFC={[...tags, ...fanClubs]} ssr={ssr} />
              {ads && <Ad {...ads.adSideBottom}/>}
            </div>
          </div>
          {/* Similar articles are going to be just the article with the same
            category as the current article minus itself */}
          {ads && <Ad {...ads.adLead}/>}
          <LazyLoadedSimilarElement id={id} cate={cate} ssr={ssr} />
          {lazyLoadedPrefooterElement}
        </div>
      </div>
    )
  }
}

export default ArticleRender



// WEBPACK FOOTER //
// ./assets/js/components/article/ArticleRender.jsx